import { render, staticRenderFns } from "./EnviarSolicitudAprobacion.vue?vue&type=template&id=b49457c0&scoped=true&"
import script from "./EnviarSolicitudAprobacion.vue?vue&type=script&lang=js&"
export * from "./EnviarSolicitudAprobacion.vue?vue&type=script&lang=js&"
import style0 from "./EnviarSolicitudAprobacion.vue?vue&type=style&index=0&id=b49457c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49457c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VChip,VCol,VContainer,VDivider,VIcon,VRow,VSimpleTable})
